<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import VisitasTable from './visitas-table.vue'
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/visita_anim.json'
import exportFromJSON from "export-from-json";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Visitas",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, VisitasTable, Loader, Vue3Lottie },
  data() {
    return {
      animationJson,
      title: 'Visitas',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Visitas',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      visitasList: null,
      visChart1: null,
      visChart2: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      visAtendido: 0,
      visProgramado: 0,
      visCancelado: 0,

    }
  },
  methods: {
    relPlanTel(){
      console.log('relPlanTel')

      api.get(`${getBaseUrl()}api/relexportzap`).then((res) => {
        console.log('then axios')
        console.log(res.data)


        const data = res.data
        const fileName = "exp_dados";
        const exportType = exportFromJSON.types.xls;
        if (data) exportFromJSON({ data, fileName, exportType });


        this.updating = false
      });

    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.visitasList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/visitas`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])

        this.visitasList = res.data[0]
        this.title = `(${this.visitasList.length}) Visitas`
        this.loadingList = false


        let contTotalAtend = 0
        let contTotalProgr = 0
        let contTotalCancel = 0
        this.visitasList.forEach((value) => {
          if (value.status === 'A'){
            contTotalAtend += 1
          } else if (value.status === 'P'){
            contTotalProgr += 1
          } else if (value.status === 'X'){
            contTotalCancel += 1
          }
        })

        this.visAtendido = contTotalAtend
        this.visProgramado = contTotalProgr
        this.visCancelado = contTotalCancel

        // console.log('res.data[1]')
        // console.log(res.data[1])
        let labelsLocG1 = []
        let series01G1 = []
        res.data[1].forEach((value) => {
          labelsLocG1.push(value.cliente)
          series01G1.push(value.contagem)
        })
        this.visChart1 = {
          series: [{
            data: series01G1
          }],
          chartOptions: {
            chart: {
              toolbar: {
                show: false,
              }
            },
            plotOptions: {
              bar: {
                horizontal: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            colors: ['#34c38f'],
            grid: {
              borderColor: '#f1f1f1',
            },
            xaxis: {
              categories: labelsLocG1,
            }
          }

        }



        let labelsLocG2 = []
        let series01G2 = []
        let contTotal = 0
        res.data[1].forEach((value) => {
          contTotal += parseInt(value.contagem)
        })
        console.log('contTotal_G2')
        console.log(contTotal)
        res.data[1].forEach((value) => {
          console.log(value)
          labelsLocG2.push(value.cliente)
          const valorPerc = parseInt(value.contagem / contTotal * 100)
          console.log(valorPerc)
          series01G2.push(valorPerc)
        })

        this.visChart2 = {
          series: series01G2,
          chartOptions: {
            labels: labelsLocG2,
            colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'center',
              verticalAlign: 'middle',
              floating: false,
              fontSize: '14px',
              offsetX: 0
            },
            responsive: [{
              breakpoint: 600,
              options: {
                chart: {
                  height: 240
                },
                legend: {
                  show: false
                },
              }
            }]
          }

        }




        this.loadingGraph = false
      });
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)

      this.loadingList = true
      api.delete(`${getBaseUrl()}api/visita`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg(regSelecionado) {
      console.log('alterouReg_pai')
      console.log(regSelecionado)
      this.atualizaDataList()
    },

    criarNova() {
      console.log('criarNova')
      this.$refs.childTable.setCriarNova(true)

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }
  },
  mounted() {
    console.log('mounted visitas-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 55px; right: 180px;">
      <Vue3Lottie :animationData="animationJson" :height="170" :width="170" />
    </span>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Atendido</option>
                      <option value="P">Programado</option>
                      <option value="X">Cancelado</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatInteger(visitasList.length) }} (Visitas) </h5>
                      </div>
                    </div>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item>
                      Programado:
                      <span class="float-end"> {{ formatInteger(visProgramado) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Atendido:
                      <span class="float-end"> {{ formatInteger(visAtendido) }} (0%)</span>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      Cancelado:
                      <span class="float-end"> {{ formatInteger(visCancelado) }} (0%)</span>
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportExcel"
                       href="javascript: void(0);">
                      Exportar Excel
                    </a>

                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="relPlanTel"
                       href="javascript: void(0);">
                      Exportar Planilha Telefones
                    </a>

                  </div>

                </b-dropdown>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNova">
                    <i class="mdi mdi-plus me-1"></i> Nova Visita
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <VisitasTable v-if="!loadingList"
                            ref="childTable"
                            :visitasList="visitasList"
                            @deletareg="deletouReg"
                            @alterareg="alterouReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!loadingGraph">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Top 10 Clientes</h4>
            <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="visChart1.series"
                :options="visChart1.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Destaques Semana</h4>
            <apexchart
                class="apex-charts"
                height="320"
                type="donut"
                dir="ltr"
                :series="visChart2.series"
                :options="visChart2.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>
